import { cosignatureRequestsTyped } from "@/api/(requests)/cosignatureTyped";
import type { GetNoteHistoryResponse } from "@/core/types/(api)/cosignature";
import type { UUID } from "@/core/types/common";

import { noteHistorySchema } from "../../types/schema";

export async function getNoteHistory(
  noteId: UUID,
  signal?: AbortSignal,
): Promise<GetNoteHistoryResponse> {
  const history = await cosignatureRequestsTyped.get_note_history({
    context: { showLoader: false },
    signal,
    urlParams: { noteId },
  });

  // Validate without reshaping the typed response or relying on Zod's non-strict type inference.
  noteHistorySchema.parse(history);

  return history;
}
